import createAction from '@wix/communities-blog-client-common/dist/src/services/create-action';

export const SET_USER_AGENT = 'userAgent/SET';

export const setUserAgent = createAction(SET_USER_AGENT);
